import webServiceErrorHandler from '@/errorManagement/webServiceErrorHandler';
import { HANDLING_CODES } from '@/errorManagement/utils';
import { reportJSError } from '@/utils/common';

export const normalizeErrorInfo = (error, service, contextApi) => {
  const errorInfo = { ...webServiceErrorHandler[service] };
  try {
    const { handlingCode, errorToPrint } = { ...errorInfo };
    const { status: errorCode } = { ...error };
    errorInfo.handlingCode = handlingCode[errorCode] || handlingCode.default;
    errorInfo.errorToPrint = errorToPrint[errorCode] || errorToPrint?.default;
    errorInfo.setError =
      errorInfo.handlingCode !== HANDLING_CODES.NOTHING_TO_DO;
    return errorInfo;
  } catch (e) {
    reportJSError(e, 'normalizeErrorInfo', 'utils/saga-utils', contextApi);
    return { ...errorInfo, handlingCode: -1 };
  }
};
